<template>
    <div>
        <label :style="'color:' + fieldsColor" :class="{'required': field.required}"
               v-if="path.hideTitle === undefined || !path.hideTitle">
            {{ field.name }}
            <help-tooltip :content="field.helpDescription"></help-tooltip>
        </label>

        <v-text-field
            class="mb-5"
            :value="fieldValue"
            @input="updateFieldValue"
            type="number"
            step="2"
            min="0"
            hide-details
            outlined
            :class="{'input-error': submitted && field.required && (fieldValue === null || fieldValue === '')}"
        >
        </v-text-field>
    </div>
</template>

<script>

import {mapGetters, mapMutations, mapState} from "vuex"
import {fieldsMapping} from "../../../../static/webform"

import HelpTooltip from "../../../tools/HelpTooltip.vue"

export default {
    name: "FormNumeric",
    props: ['field'],
    components: {HelpTooltip},
    methods: {
        ...mapMutations('web_form', ['updateProviderFieldValue']),
        updateFieldValue(value) {
            this.updateProviderFieldValue([this.path, value])
        }
    },
    computed: {
        ...mapState("webFormStyle", ["fieldsColor"]),
        ...mapState("web_form", ['submitted', 'provider', 'aiEnabled']),
        ...mapGetters('web_form', ['getCodeFromField', 'getProviderFieldValue']),
        fieldCode() {
            return this.getCodeFromField(this.field)
        },
        path() {
            return fieldsMapping.find(path => path.code === this.fieldCode)
        },
        fieldValue() {
            return this.getProviderFieldValue(this.path)
        }
    }
}
</script>